import { render, staticRenderFns } from "./repartition-doughnut.vue?vue&type=template&id=6a2dc872&scoped=true"
import script from "./repartition-doughnut.vue?vue&type=script&lang=js"
export * from "./repartition-doughnut.vue?vue&type=script&lang=js"
import style0 from "./repartition-doughnut.vue?vue&type=style&index=0&id=6a2dc872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2dc872",
  null
  
)

export default component.exports